import { MessageType } from '../hooks/useSocket/useSocket.types'
import { SafeTFunction } from '../../out-game/hooks/useTranslationStrict/useTranslationStrict.types'

export const sortMessagesByDate = (messages: MessageType[]) => {
  return messages.sort(
    (a, b) =>
      new Date(a.created_at).getTime() - new Date(b.created_at).getTime()
  )
}

export enum ErrorEnum {
  ForeignLink = 'foreign_link',
  NoActiveSubscription = 'no_active_subscription',
  SendMessageIsBlocked = 'send_message_is_blocked',
  UserHasNotJoinedChat = 'user_has_not_joined_the_chat',
  ItemNotExists = 'item_not_exists',
  MessageTooLong = 'message_too_long',
}

export const getErrorText = (errorCode: ErrorEnum | string, t: SafeTFunction) => {
  // TODO: translate all errors
  switch (errorCode) {
    case ErrorEnum.ForeignLink:
      return 'В чате нельзя отправлять ссылки на сторонние ресурсы'
    case ErrorEnum.NoActiveSubscription:
      return t('errors.noActiveSubscription')
    case ErrorEnum.SendMessageIsBlocked:
      return 'Пардон! Вас заблокировали, так как Вы нарушили правила пользования общим чатом.'
    case ErrorEnum.UserHasNotJoinedChat:
      return 'Пользователь не подключился к чату'
    case ErrorEnum.ItemNotExists:
      return 'Неправильная ссылка: такого товара нет в продаже'
    case ErrorEnum.MessageTooLong:
      return 'Сообщение слишком длинное. Сообщение должно быть не более 500 символов'
    default:
      return 'Произошла ошибка'
  }
}
